/*!
 * @author: Elton Jain (@eltonjain)
 *
 */
require.config({
    baseUrl: 'assets/js',
    paths: {
        // Vendors
        // async: 'vendor/require/async.require',        // Async plugin for require JS
        jquery: 'vendor/jquery-2.2.2.min',              //
        functions: 'modules/common/Functions',                  // Open Javascript Functions

        // jquery: '//ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min',             // jQuery 1.* / compatible IE6+
        facebook: 'modules/auth/facebook',    // Facebook SDK
        google: 'modules/auth/google',    // Facebook SDK
        //jquery: 'vendor/jquery-1.11.2.min',            // jQuery 1.* / compatible with IE8
        //underscore: 'vendor/underscore',               // Underscore JS
        //backbone: 'vendor/backbone',                   // Backbone JS
        //text: 'vendor/require/text.require',           // Text plugin for require JS
        autosize: 'vendor/autosize.min',                 // Autosize jquery plugin
        // timeago: 'vendor/timeago.min',                   // Timeago jquery plugin
        cookie: 'vendor/cookie',                         // Jquery Cookies plugin
        linkifyCore: 'vendor/linkify/linkify.min',                         // Convert HTML to links
        linkify: 'vendor/linkify/linkify-jquery.min',                         // Convert HTML to links
        countdown: 'vendor/countdown',                // Countdown js, modified
        glide: 'vendor/glide.min',                          // Countdown js, modified

        // tmpl: 'vendor/js-templates/tmpl.min',         // Javscript-Templates (template engine)
        JSTemplate: 'templates/mobile/compiled.min',       // Compiled Javscript-Templates (template engine)
        fuse: 'vendor/fuse-search.min',                  // Fuse Search
        // dropsearch: 'modules/common/DropSearch',         // DropSearch lib
        Tabber: 'modules/common/Tabber',                // Tabber
        // lightslider: 'vendor/lightslider.min',               // LightSlider
        Mixpanel: 'modules/common/MixPanel',               // MixPanel
        DataList: 'modules/common/DataList',
        Toastr: 'modules/common/Toastr',
        ImageForm: 'modules/common/ImageForm',

        // Project
        UI: 'modules/common/UI',
        User: 'modules/User',
        Auth: 'modules/auth/Auth',
        Helper: 'modules/common/Helper',

        //Slider
        Slider: 'modules/common/aminoSlider',

        // Validation
        ValidateJS: 'vendor/validate.min',                  // Validation library
        Validation: 'modules/common/Validation',            // Custom Validation wrapper

        // Feed
        Feed: 'modules/Feed/Feed',
        FeedAskQuestion: 'modules/Feed/AskQuestion',
        FeedQuestions: 'modules/Feed/FeedQuestions',
        FeedAnswers: 'modules/Feed/FeedAnswers',
        Contests: 'modules/Contests',

        // Groups
        Groups: 'modules/Groups',

        // Config
        Config: 'modules/common/Config',

        // Tooltip
        Tooltip: 'modules/common/Tooltip',

        // Carousel
        Carousel: 'modules/common/Carousel',

        // History
        History: 'modules/common/History',

        // PhotoBooth
        PhotoBooth: 'modules/common/PhotoBooth',

        // Kids Info
        KidsInfo: 'modules/common/KidsInfo',

        // Date picker
        DatePicker: 'modules/common/zebra_datepicker',

        // caret
        caret: 'vendor/jquery.caret.min',

        //tags
        tags: 'vendor/jquery.tag-editor.min',

        Tracker: 'modules/Tracker'
    },

    shim: {
        jquery : {
            exports: '$',
        },
        timeago: {
            deps: ['jquery']
        },
        dropsearch: {
            deps: ['jquery']
        },
        cookie: {
            deps: ['jquery']
        },
        JSTemplate: {
            exports: 'JSTemplate',
            deps: ['functions']
        },
        linkify: {
           exports: 'linkify',
           deps: ['jquery', 'linkifyCore']
        },
        countdown: {
           exports: 'countdown',
           deps: ['jquery']
        },
        glide: {
            deps: ['jquery']
        },
        caret: {
            deps: ['jquery']
        },
        tags: {
            deps: ['jquery']
        },
        Slider: {
            deps: ['jquery']
        }
    },
    waitSeconds: 0
});

require([
    'jquery',
    'app'
], function ($, App) {
    "use strict";
    App.init();
});
define("main", function(){});

